

import React from 'react';
import { useIntl } from 'umi';
import NoData from '@home/components/NavHeader/sreachContext/components/NoData';
import './index.scss';

const StudioState = (props: { isNoPermission?: boolean; }) => {
  const { formatMessage } = useIntl();
  const { isNoPermission = false } = props || {};
  return <NoData
    className='dbh-studio-state'
    title={''}
    text={isNoPermission ? formatMessage({ id: 'dbh_studio_no_permission_view' }) : formatMessage({ id: 'dbh_studio_no_access_view' })}
  />;
};

export default StudioState;